var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08975 17.0833C5.67415 17.0833 5.31919 16.9361 5.02485 16.6418C4.73051 16.3475 4.58333 15.9925 4.58333 15.5769V4.99999H4.375C4.19765 4.99999 4.04915 4.94017 3.9295 4.82051C3.80983 4.70086 3.75 4.55236 3.75 4.37501C3.75 4.19767 3.80983 4.04917 3.9295 3.92951C4.04915 3.80985 4.19765 3.75001 4.375 3.75001H7.49998C7.49998 3.54596 7.57183 3.37208 7.71552 3.22839C7.85922 3.0847 8.03309 3.01285 8.23715 3.01285H11.7628C11.9669 3.01285 12.1407 3.0847 12.2844 3.22839C12.4281 3.37208 12.5 3.54596 12.5 3.75001H15.625C15.8023 3.75001 15.9508 3.80985 16.0705 3.92951C16.1901 4.04917 16.25 4.19767 16.25 4.37501C16.25 4.55236 16.1901 4.70086 16.0705 4.82051C15.9508 4.94017 15.8023 4.99999 15.625 4.99999H15.4166V15.5769C15.4166 15.9925 15.2695 16.3475 14.9751 16.6418C14.6808 16.9361 14.3258 17.0833 13.9102 17.0833H6.08975ZM14.1666 4.99999H5.83331V15.5769C5.83331 15.6517 5.85735 15.7131 5.90544 15.7612C5.95352 15.8093 6.01496 15.8333 6.08975 15.8333H13.9102C13.985 15.8333 14.0464 15.8093 14.0945 15.7612C14.1426 15.7131 14.1666 15.6517 14.1666 15.5769V4.99999ZM7.83654 14.1667H9.08652V6.66666H7.83654V14.1667ZM10.9134 14.1667H12.1634V6.66666H10.9134V14.1667Z",
    fill: "#DA291C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconRed);
export default __webpack_public_path__ + "static/media/deleteIconRed.15c293e3ecf7c3f78faa688a75d46e75.svg";
export { ForwardRef as ReactComponent };